<template>
    <v-layout row wrap>
        <v-flex xs12>
            <div class="m-block-form-title-title">
                <e-typography-heading-1 tag="h2">
                    <slot/>
                </e-typography-heading-1>
            </div>
            <e-divider-secondary class="m-block-form-title-divider"/>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "m-block-form-title"
    }
</script>

<style scoped lang="scss" >
    .m-block-form-title-title{
        margin-bottom: 40px;
        @include media(md) {
            margin-bottom: 32px;
        }
        @include media(sm) {
            margin-bottom: 20px;
        }
    }
</style>
